import React from 'react'
import { StitchAppContainer } from '../app/[appId]'

export function StreamingScreeningPage() {
  return (
    <StitchAppContainer slug={`streamify`} /> 
  )
}

export default StreamingScreeningPage